import React, { useState , useEffect , useRef} from 'react';
import { Link, useLocation } from 'react-router-dom';
import { menuItems } from './menuconfig';
import './HamburgerMenu.css';

const HamburgerMenu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef<HTMLElement>(null); 

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  // ★ メニュー外クリックを検知する処理
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // メニューが開いている、かつ、クリックされた要素がメニュー(menuRef)の中に含まれていない場合
      if (isOpen && menuRef.current && !menuRef.current.contains(event.target as Node)) {
        // さらに、ハンバーガーボタン自体をクリックした時は無視（toggleMenuと競合するため）
        const isButton = (event.target as HTMLElement).closest('.hamburger-button');
        if (!isButton) {
          closeMenu();
        }
      }
    };

    // 画面全体にクリックイベントを登録
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // クリーンアップ
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);
  

  return (
    <>
      {/* ハンバーガーボタン */}
      <button 
        className={`hamburger-button ${isOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        aria-label="メニュー"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>



      {/* メニュー本体 */}
      <nav ref={menuRef} className={`hamburger-nav ${isOpen ? 'open' : ''}`}>
        <ul>
          {menuItems.map((item) => {
            const Icon = item.icon; // コンポーネントを変数に代入（JSXで使うため大文字で開始）
            return (
              <li key={item.path}>
                <Link 
                  to={item.path}
                  state={{ fromMenu: true }}
                  onClick={closeMenu}
                  className={location.pathname === item.path ? 'active' : ''}
                >
                  <div className="menu-item-content">
                    <span className="menu-item-icon">{Icon && <Icon />}</span>
                    <span className="menu-item-label">{item.label}</span>
                  </div>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </>
  );
};

export default HamburgerMenu;
